<div class="request-sidebar-container" [ngStyle]="{'width': width}" [ngClass]="{'hide-in-spatial-size': hide}"
    tcClickOutSide (clickOutside)="closeSideBarInModalMode($event)">
    <i class="icon-cancel" (click)="close()"></i>
    <mat-tab-group [selectedIndex]="tabSelectedIndex" mat-stretch-tabs="false">
        <mat-tab *ngIf="showHelp">
            <ng-template mat-tab-label>
                <span class="lbl-help">{{'GENERAL.HELP' | translate}}</span>
            </ng-template>
            <ng-template matTabContent>
                <tc-help-desk [helpDeskContentType]="helpDeskContentType"></tc-help-desk>
            </ng-template>
        </mat-tab>
        @if(isCryptoWithdraw !== true){
        <mat-tab>
            <ng-template mat-tab-label>
                <!--    <mat-icon class="message-icon">mail_outline</mat-icon> -->
                {{'GENERAL.MESSAGE' | translate}}
            </ng-template>

            <ng-template matTabContent>
                <tc-request-message [canActive]="showHelp" [requestId]="requestId" [isCryptoWithdraw]="isCryptoWithdraw"
                    (isSidebarLockedEmit)="onSidebarLockedChange($event)"></tc-request-message>
            </ng-template>
        </mat-tab>
        }
    </mat-tab-group>
</div>
<div class="backdrop"></div>